import { List, Typography } from "antd";
import { ReactNode } from "react";

export function formatErrors(errores: string[]): ReactNode {
  return (
    <List
      header="Se detectaron algunas inconsistencias en el reporte Json"
      dataSource={errores}
      renderItem={(item) => {
        const isToFormat = item.startsWith("El campo");
        const listString = isToFormat ? item.split(" ") : [];

        return (
          <div>
            {!isToFormat && (
              <List.Item>
                <Typography.Text type="danger"> {item}</Typography.Text>
              </List.Item>
            )}
            {isToFormat && (
              <List.Item>
                <List.Item.Meta
                  title={
                    <div>
                      <Typography.Text strong ellipsis>
                        {listString[2]}
                      </Typography.Text>
                    </div>
                  }
                  description={
                    <div>
                      {listString.slice(0, 2).join(" ").concat(" ")}
                      <Typography.Text mark>
                        {listString[2].concat(" ")}
                      </Typography.Text>
                      {listString.slice(3).join(" ")}
                    </div>
                  }
                />
              </List.Item>
            )}
          </div>
        );
      }}
    />
  );
}

export function transformErrorStringToList(value: string): string[] {
  const transform = value
    .replace(/\[|\]/g, "") // Elimina corchetes ([) y ()])
    .replace(/"/g, "") // Elimina comillas dobles
    .split(",")
    .map((item) => item.trim());
  return transform;
}

/**
 * Determina si la respuesta de errores del Json está vacía o no contiene errores reales.
 * Considera como "sin errores" los siguientes casos:
 * - El valor es undefined o null
 * - Cadena vacía: ""
 * - Arreglo JSON vacío: "[]" o "[ ]"
 */
export function hasNoErrors(errors?: string): boolean {
  return !errors || errors === "" || errors === "[]" || errors === "[ ]";
}
